import thunk from "redux-thunk";
import { rootReducer } from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const sagaMiddleware = createSagaMiddleware();

let middlewares = [thunk, sagaMiddleware];

const persistConfig = {
  key: "root",
  storage,
};

let store = configureStore({
  reducer: rootReducer,
  middleware: middlewares,
  devTools:true
});

sagaMiddleware.run(rootSaga);

export { store };

export * from "./constants";
